import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getAccountDetails } from '../../../../actions/adminActions';

import UserTeamAccountList from './UserTeamAccountList';
import TeamListBox from '../../TeamListBox/TeamListBox';

class UserTeams extends Component {
  static propTypes = {
    activeTeam: PropTypes.instanceOf(Object),
    activeAccounts: PropTypes.instanceOf(Array),
    accounts: PropTypes.instanceOf(Array),
    updatedTeam: PropTypes.func,
  };
  static defaultProps = {
    activeTeam: {},
  };

  state = {
    accounts: [],
    activeTeams: {},
    teams: '',
    hasAccounts: true,
    availableTeams: {},
    fetchTeam: true,
    activeAccountId: '',
  };

  UNSAFE_componentWillMount() {
    this.getUserTeams();
  }
  getUserTeams = () => {
    const response = this.props.activeTeam;
    const activeAccounts = this.props.activeAccounts;
    const allAccounts = this.props.accounts;
    if (_.isEmpty(activeAccounts)) {
      this.setState({ hasAccounts: false });
    } else {
      const teams = response ? _.groupBy(response, 'accountId') : {};
      const accounts = [];
      allAccounts.map(account => {
        const { accountId, accountType, publicId } = account;
        const activeAccount = _.filter(
          activeAccounts,
          item => item.accountId === accountId
        );
        const accountName =
          account.accountType === 'TPP'
            ? account.accountName + ' (Third Party)'
            : account.accountName;
        const selected = activeAccount.length > 0;
        if (selected) {
          accounts.push({
            accountId,
            accountName,
            publicId,
          });
        }
        return null;
      });
      this.setState({ accounts, teams, hasAccounts: true, activeTeams: teams });
    }
  };

  handleAccountChange = (accountId, publicId) => {
    this.setState({ fetchTeam: true, activeAccountId: accountId }, () => {
      getAccountDetails(publicId).then(response => {
        if (response) {
          const availableTeams = _.cloneDeep(this.state.availableTeams);
          availableTeams[accountId] = response.teams || [];
          this.setState({
            availableTeams,
            fetchTeam: false,
          });
        }
      });
    });
  };

  updateSelectedItems = activeTeams => {
    const { activeAccountId } = this.state;
    const newActiveTeams = _.cloneDeep(this.state.activeTeams);
    newActiveTeams[activeAccountId] = activeTeams;
    this.setState({ activeTeams: newActiveTeams }, () => {
      const activeTeamItems = [];
      const activeTeam = [];

      Object.keys(this.state.activeTeams).map(item => {
        this.state.activeTeams[item].map(team => {
          activeTeam.push(team.id);
          return false;
        });
        return false;
      });

      Object.keys(this.state.availableTeams).map(item => {
        this.state.availableTeams[item].map(team => {
          const hasKey = activeTeam.includes(team.id);
          if (hasKey) {
            activeTeamItems.push(team);
          }
          return false;
        });
        return false;
      });

      const groupedTeams = _.cloneDeep(newActiveTeams);
      const groupedActiveTeams = _.groupBy(activeTeamItems, 'accountId');
      if (
        groupedActiveTeams[activeAccountId] &&
        groupedActiveTeams[activeAccountId].length > 0
      ) {
        groupedTeams[activeAccountId] = groupedActiveTeams[activeAccountId];
      } else {
        groupedTeams[activeAccountId] = [];
      }
      _.map(activeTeamItems, item => {
        if (item.accountId !== activeAccountId) {
          const hasRole = _.filter(
            groupedTeams[item.accountId],
            rl => rl.id === item.id
          );
          if (_.isEmpty(hasRole)) {
            groupedTeams[item.accountId] = [
              ...groupedTeams[item.accountId],
              item,
            ];
          }
        }
      });

      let updatedTeams = [];
      Object.keys(groupedTeams).map(ac => {
        updatedTeams = [...updatedTeams, ...groupedTeams[ac]];
        return false;
      });

      this.props.updatedTeam(updatedTeams);
    });
  };

  renderTeamBox = () => {
    const {
      availableTeams,
      activeTeams,
      fetchTeam,
      activeAccountId,
    } = this.state;
    let renderTeamBox = '';
    if (_.isEmpty(availableTeams[activeAccountId]) && !fetchTeam) {
      renderTeamBox = (
        <div className="accounts-role-users user-team-box">
          <div className="no-team padding-20">
            No Team assigned to this account!
          </div>
        </div>
      );
    } else if (!_.isEmpty(availableTeams[activeAccountId])) {
      renderTeamBox = (
        <div className="accounts-role-users user-team-box">
          <TeamListBox
            teams={availableTeams[activeAccountId].filter(
              data => data.activeStatus !== 'N'
            )}
            activeTeams={activeTeams[activeAccountId]}
            updateSelectedItems={this.updateSelectedItems}
            clearUsers={false}
          />
        </div>
      );
    }
    return renderTeamBox;
  };

  render() {
    const { accounts, teams, hasAccounts } = this.state;

    let rendercontent = <div>loading...</div>;
    if (_.isEmpty(accounts) && !hasAccounts) {
      rendercontent = <div className="no-accounts">No Account assigned.</div>;
    } else if (!_.isEmpty(accounts)) {
      rendercontent = (
        <div>
          <UserTeamAccountList
            teams={teams}
            handleAccountChange={this.handleAccountChange}
            accounts={accounts}
          />
          {this.renderTeamBox()}
        </div>
      );
    }
    return (
      <div className="user-roles user-teams">
        <div className="accounts-role--details">{rendercontent}</div>
      </div>
    );
  }
}

export default UserTeams;
